import { motion } from "framer-motion";
import { ListMusic, ExternalLink } from "lucide-react";

const fmtAdded = (iso) => {
  if (!iso) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return iso;
  return `${Number(m[2])}/${Number(m[3])}/${m[1].slice(2)}`;
};

// Editorial playlist placements for a song (real audit data). Renders only when the song has
// placements, so it never appears on songs without this data.
export function EditorialPlacements({ placements, source, className = "" }) {
  if (!Array.isArray(placements) || placements.length === 0) return null;
  return (
    <motion.section
      data-testid="editorial-placements"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      className={`pb-card p-5 ${className}`}
    >
      <div className="flex items-center gap-2">
        <span className="grid h-7 w-7 place-items-center rounded-lg bg-[#35606E] text-white">
          <ListMusic className="h-4 w-4" />
        </span>
        <h2 className="font-display text-base font-extrabold leading-tight">Editorial placements</h2>
      </div>

      <div className="mt-4 overflow-x-auto">
        <table className="w-full min-w-[640px] border-collapse text-sm">
          <thead>
            <tr className="text-left text-[11px] font-semibold uppercase tracking-wide text-neutral-500">
              <th className="px-3 py-2">Platform</th>
              <th className="px-3 py-2">Playlist</th>
              <th className="px-3 py-2">Type</th>
              <th className="px-3 py-2">Position</th>
              <th className="px-3 py-2">Followers</th>
              <th className="px-3 py-2">Added</th>
            </tr>
          </thead>
          <tbody>
            {placements.map((r, i) => (
              <tr
                key={`${r.platform}-${r.playlist}-${i}`}
                data-testid={`editorial-row-${i}`}
                className="border-t border-black/[0.06]"
              >
                <td className="px-3 py-2.5 font-semibold text-[#111]">{r.platform}</td>
                <td className="px-3 py-2.5">
                  {r.url ? (
                    <a
                      href={r.url}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1 font-medium text-[#35606E] underline-offset-2 hover:underline"
                    >
                      {r.playlist} <ExternalLink className="h-3 w-3" />
                    </a>
                  ) : (
                    <span className="font-medium">{r.playlist}</span>
                  )}
                </td>
                <td className="px-3 py-2.5 text-neutral-600">{r.type || "—"}</td>
                <td className="num-display px-3 py-2.5 text-neutral-700">{r.position || "—"}</td>
                <td className="num-display px-3 py-2.5 text-neutral-700">{r.followers ?? "—"}</td>
                <td className="num-display px-3 py-2.5 text-neutral-500">{fmtAdded(r.added)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {source && <p className="mt-3 text-[11px] text-neutral-400">Source: {source}</p>}
    </motion.section>
  );
}
